import parse from "html-react-parser"
import classnames from "classnames"

import styles from "./chat_header_icon_button.module.scss"

type Props = {
  icon: string
  title: string
  className?: string
} & ({ onClick: () => void; href?: never } | { href: string; onClick?: never })

const ChatHeaderIconButton = ({ icon, title, onClick, href, className }: Props) => {
  const cls = classnames(styles["chat-header-icon-button"], className)

  if (href) {
    return (
      <a className={cls} title={title} aria-label={title} href={href} target="_blank" rel="noreferrer">
        {parse(icon)}
      </a>
    )
  }

  return (
    <button type="button" className={cls} title={title} aria-label={title} onClick={onClick}>
      {parse(icon)}
    </button>
  )
}

export default ChatHeaderIconButton
